// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0766d07e","535":"9f64afa4","655":"40231c76","703":"38afca75"}[chunkId] + ".chunk.js";
};